import * as React from 'react';
import type { ExternalAgentId } from './externalAgents';

// Claude's spark: uneven rays around a centre, in Claude's clay orange.
const CLAUDE_RAYS: Array<[angle: number, length: number]> = [
  [0, 9.5], [33, 8], [62, 9.5], [95, 7.5], [124, 9], [152, 8],
  [185, 9.5], [214, 7.5], [243, 9], [272, 8.5], [303, 9.5], [331, 7.5],
];

const ClaudeLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" focusable={false} aria-hidden {...props}>
    {CLAUDE_RAYS.map(([angle, length]) => {
      const rad = (angle * Math.PI) / 180;
      return (
        <line
          key={angle}
          x1={12 + Math.cos(rad) * 2}
          y1={12 + Math.sin(rad) * 2}
          x2={12 + Math.cos(rad) * length}
          y2={12 + Math.sin(rad) * length}
          stroke="#D97757"
          strokeWidth={2.2}
          strokeLinecap="round"
        />
      );
    })}
  </svg>
);

// A neutral rosette rather than OpenAI's exact mark.
const ChatGptLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" focusable={false} aria-hidden {...props}>
    {[0, 60, 120].map((angle) => (
      <ellipse
        key={angle}
        cx={12}
        cy={12}
        rx={9}
        ry={4.2}
        transform={`rotate(${angle} 12 12)`}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
      />
    ))}
  </svg>
);

const LOGOS: Record<ExternalAgentId, React.FC<React.SVGProps<SVGSVGElement>>> = {
  claude: ClaudeLogo,
  chatgpt: ChatGptLogo,
};

export const AgentLogo = ({
  agent,
  ...props
}: { agent: ExternalAgentId } & React.SVGProps<SVGSVGElement>) => {
  const Logo = LOGOS[agent];
  return <Logo {...props} />;
};

export default AgentLogo;
